export const dayNames = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
] as const;

export const dayNamesAndEveryday = [...dayNames, 'EVERY_DAY'] as const;

export type DayName = (typeof dayNames)[number];

export type DayNameOrEveryDay = (typeof dayNamesAndEveryday)[number];
